<script setup>
import { computed } from 'vue'

const props = defineProps({
  statuses: {
    type: Array,
    default: [
      { name: 'Hinnatud', value: 'finalized' },
      { name: 'Hindamisel', value: 'in_progress' },
    ],
  },
})

const emit = defineEmits(['update:selectedStatus'])

const selectedStatus = defineModel('selectedStatus', {
  type: String,
  default: '',
})

const label = computed(() => {
  return props.statuses.find(s => s.value === selectedStatus.value)?.name
})

const getStatusIcon = computed(() => {
  if (!selectedStatus.value) return {}

  switch (selectedStatus.value) {
    case true:
    case 'finalized':
      return {
        icon: 'pi pi-check',
        class: 'text-green-700',
      }
    case false:
    case 'hidden':
      return {
        icon: 'pi pi-eye-slash',
        class: 'text-red-700',
      }
    case 'in_progress':
      return {
        icon: 'pi pi-clock',
        class: 'text-yellow-700',
      }
    default:
      return {}
  }
})

const getStatusStyle = computed(() => {
  if (!selectedStatus.value) {
    return {
      background: 'bg-gray-100',
      border: 'border-gray-200',
      text: 'text-gray-500',
    }
  }

  switch (selectedStatus.value) {
    case true:
    case 'finalized':
      return {
        background: 'bg-green-300',
        border: 'border-green-750',
        text: 'text-green-700',
      }
    case 'in_progress':
      return {
        background: 'bg-yellow-300',
        border: 'border-yellow-750',
        text: 'text-yellow-700',
      }
    default:
      return {
        background: 'bg-gray-100',
        border: 'border-gray-200',
        text: 'text-gray-500',
      }
  }
})
</script>

<template>
    <div class="flex items-center gap-2">
      <label for="evaluation-status" class="w-1/3 text-right text-sm">
        Staatus
      </label>
      <div class="w-2/3">
        <Select
          id="evaluation-status"
          v-model="selectedStatus"
          :class="[
            getStatusStyle.background,
            getStatusStyle.border,
            getStatusStyle.text,
            'overflow-hidden transition-all duration-300 ease-in-out',
            'w-40',
          ]"
          :options="statuses"
          optionLabel="name"
          optionValue="value"
          :pt="{
            root: 'border-none',
            dropdownicon: getStatusStyle.text,
          }"
          :pt-options="{
            mergeProps: true
          }"
          size="small"
          @update:model-value="emit('update:selectedStatus', $event)"
        >
          <template #value="slotProps">
            <div
              v-if="slotProps.value"
              :class="getStatusStyle.text"
              class="flex items-center gap-2"
            >
              <span
                class="w-4"
                :class="getStatusIcon.class + ' ' + getStatusIcon.icon"
              />
              <div class="font-bold">
                {{ label }}
              </div>
            </div>
            <span v-else>{{ slotProps.placeholder }}</span>
          </template>
          <template #option="slotProps">
            <div class="flex items-center rounded-md overflow-hidden gap-1">
              <div>{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Select>
      </div>
  </div>
</template>